import React, {useCallback} from 'react';
import {Form} from '@/_application/core/components/ui/forms/form';
import {
    AuthenticationFaq,
    LoginForm,
    OtpChannelSelector,
    useAuth,
    OtpVerification,
    RegisterForm,
    type GenericFormComponent,
} from '@kidslabs/module-auth';

import styles from './otp.module.css';

export const OtpLogin = () => {
    const {currentStep} = useAuth();
    const FormComponent = Form as unknown as GenericFormComponent;

    const renderContent = useCallback(() => {
        switch (currentStep) {
            case 'EnterPhoneNumber':
                return <LoginForm FormComponent={FormComponent} />;
            case 'SelectChannel':
                return <OtpChannelSelector FormComponent={FormComponent} />;
            case 'VerifyOtp':
                return <OtpVerification />;
            case 'Register':
                return <RegisterForm FormComponent={FormComponent} />;
            case 'Faq':
                return <AuthenticationFaq />;
        }
    }, [FormComponent, currentStep]);

    return <div className={styles.container}>{renderContent()}</div>;
};
